<script setup lang="ts">
const { getTranslation } = useLanguage();

const { main: { hero: { title, description } }, common: { buttons } } = getTranslation();
</script>

<template>
  <section class="relative overflow-hidden mb-10">
    <CommonContainer class="!w-full !mx-0 !px-0">
      <div class="grid relative gap-8 xs:gap-14 xs:grid-cols-[1.3fr_1fr] sm:grid-cols-[1.1fr_1fr] hd:gap-20 hd:grid-cols-[1.15fr_1fr] py-0 sm:py-20 opacity-0 animate-[fade_300ms_forwards_300ms] ">
        <div
          class="
          hidden sm:flex justify-center items-center overflow-hidden
          absolute right-0 top-0 w-full sm:w-3/4 h-full py-20
          after:bg-gradient-to-r after:from-viola-400 after:to-transparent
          after:w-1/2 after:h-full after:absolute after:left-0 after:top-0"
        >
          <img
            src="/images/healistic-hero.png"
            alt="hero"
            class="object-contain"
          >
        </div>
        <div class="absolute top-0 left-0 w-1/4 h-full hidden sm:block" />
        <div class="flex flex-col relative hd+:justify-center px-10 sm:pl-20">
          <h1 class="font-semibold leading-default text-4xl 2xs:text-5xl xs:max-w-[36rem] sm:text-6xl sm:max-w-[40rem] hd:max-w-none hd:text-heading hd+:max-w-[45rem]">
            <span class="inline opacity-0 animate-top animation-delay-100 mr-3">
              {{ title.base }}
              {{ title.keyword }}
            </span>
            <span class="inline whitespace-normal sm:whitespace-nowrap opacity-0 relative animate-[fade_300ms_forwards_500ms] text-jungle-300 text-peach-300">
              {{ title.extra }}
            </span>
          </h1>

          <p class="xs:w-3/4 4k:text-lg opacity-0 animate-top animation-delay-500 text-2xl sm:text-3xl mt-8">
            <span> {{ description.prescribe }} </span>
            <br>
            <span> {{ description.delivery }} </span>
          </p>

          <div class="flex flex-col gap-4 mt-10 xs:mt-20 2xs:flex-row opacity-0 animate-fade animation-delay-500">
            <NuxtLink
              :to="RedirectConfig.prescriberWebappSignup"
              target="_blank"
            >
              <BaseButton style-type="orange">
                {{ buttons.doctor }}
              </BaseButton>
            </NuxtLink>

            <NuxtLink
              :to="RedirectConfig.customerWebapp"
              target="_blank"
            >
              <BaseButton style-type="outline">
                {{ buttons.patient }}
              </BaseButton>
            </NuxtLink>
          </div>
        </div>
        <div
          class="w-full h-full flex justify-center items-center overflow-hidden"
        >
          <img
            src="/images/healistic-hero.png"
            alt="hero"
            class="object-contain"
          >
        </div>
      </div>
    </CommonContainer>
  </section>
</template>
